import Link from "next/link"
import React, { ReactNode } from "react"

const HTTPS = "https"

type SideNavLinkProps = {
  href?: string
  children: ReactNode
}
function SideNavLink({ href = "", children }: SideNavLinkProps) {
  const isExternalUrl = href.startsWith(HTTPS)

  // 외부 링크인 경우 새 탭으로 열기
  if (isExternalUrl)
    return (
      <Link
        href={href}
        target="_blank"
        rel="noopener,noreferrer"
        className="block transition-colors hover:bg-gray-100"
      >
        {children}
      </Link>
    )

  return (
    <Link href={href} className="block transition-colors hover:bg-gray-100">
      {children}
    </Link>
  )
}

export default SideNavLink
